import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/mista',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::index
* @see app/Http/Controllers/Public/LocationController.php:22
* @route '/mista'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
export const suggest = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: suggest.url(options),
    method: 'get',
})

suggest.definition = {
    methods: ["get","head"],
    url: '/mista/navrhnout',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
suggest.url = (options?: RouteQueryOptions) => {
    return suggest.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
suggest.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: suggest.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
suggest.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: suggest.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
const suggestForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: suggest.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
suggestForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: suggest.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::suggest
* @see app/Http/Controllers/Public/LocationController.php:136
* @route '/mista/navrhnout'
*/
suggestForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: suggest.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

suggest.form = suggestForm

/**
* @see \App\Http\Controllers\Public\LocationController::store
* @see app/Http/Controllers/Public/LocationController.php:141
* @route '/mista/navrhnout'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/mista/navrhnout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Public\LocationController::store
* @see app/Http/Controllers/Public/LocationController.php:141
* @route '/mista/navrhnout'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LocationController::store
* @see app/Http/Controllers/Public/LocationController.php:141
* @route '/mista/navrhnout'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Public\LocationController::store
* @see app/Http/Controllers/Public/LocationController.php:141
* @route '/mista/navrhnout'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Public\LocationController::store
* @see app/Http/Controllers/Public/LocationController.php:141
* @route '/mista/navrhnout'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
export const show = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/mista/{location}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
show.url = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { location: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: typeof args.location === 'object'
        ? args.location.slug
        : args.location,
    }

    return show.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
show.get = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
show.head = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
const showForm = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
showForm.get = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LocationController::show
* @see app/Http/Controllers/Public/LocationController.php:68
* @route '/mista/{location}'
*/
showForm.head = (args: { location: string | { slug: string } } | [location: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
export const cover = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cover.url(args, options),
    method: 'get',
})

cover.definition = {
    methods: ["get","head"],
    url: '/mista/{location}/cover.jpg',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
cover.url = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { location: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: typeof args.location === 'object'
        ? args.location.id
        : args.location,
    }

    return cover.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
cover.get = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cover.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
cover.head = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cover.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
const coverForm = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cover.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
coverForm.get = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cover.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LocationCoverController::cover
* @see app/Http/Controllers/LocationCoverController.php:33
* @route '/mista/{location}/cover.jpg'
*/
coverForm.head = (args: { location: number | { id: number } } | [location: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cover.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cover.form = coverForm

const locations = {
    index: Object.assign(index, index),
    suggest: Object.assign(suggest, suggest),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    cover: Object.assign(cover, cover),
}

export default locations